import { CText } from '../@shared/models/text.model';

export class fPV2Data {
    index?: number;
    layoutType: string;
    layoutContent: content;
    constructor() {
        this.index = 0;
        this.layoutType = '';
        this.layoutContent = {
            button: {
                alignment: '',
                background: '',
                height: '',
                width: '',
                title: { text: '' },
                link: '',
            },
            title: { text: '', color: '' },
            featured: [],
            conformance: [],
            downloadApp: [],
            followUs: [],
            staticPages: [],
            paymentOptions: [],
            rating: { image: '0', video: '' },
            listing: [],
        };
    }
}
export interface content {
    button: {
        alignment?: string;
        background: string;
        height: string;
        width: string;
        title: CText;
        link: string;
        icon?: string;
    };
    title: { text: string; color: string };
    featured: Array<Featured>;
    conformance: Array<TextIcon>;
    downloadApp: Array<TextLink>;
    followUs: Array<TextLink>;
    staticPages: Array<SearchedData>;
    paymentOptions: Array<IconLink>;
    rating: { image: string; video: string };
    listing: Array<Listing>;
}
export interface Listing {
    title: { text: string; color: string };
    listingFeed: Array<ListingFeed>;
}
export interface ListingFeed {
    subtitle: {
        text: string;
        color: string;
    };
    listingsubfeed: Array<TextLink>;
}

export interface IconLink {
    icon: string;
    link: string;
}
export interface SearchedData {
    text: string;
    feed: Array<TextLink>;
}

export interface Featured {
    banner: {
        image: string;
    };
    image: string;
    video: string;
}
export interface TextIcon {
    text: string;
    icons: string;
}
export interface TextLink {
    text: string;
    link: string;
}

export class fPV2DataFeed {
    feed: Array<fPV2Data>;
    bottomBar: {
        color: string;
        title: {
            text: string;
            color: string;
        };
    };
    constructor() {
        this.feed = [];
        this.bottomBar = {
            color: '',
            title: {
                text: '',
                color: '',
            },
        };
    }
}
